export var shareComponent = function (name, component) {
    if (window) {
        window.__mf.shared[name] = component;
    }
    return component;
};
export var getSharedComponent = function (name) { var _a; return (_a = window === null || window === void 0 ? void 0 : window.__mf) === null || _a === void 0 ? void 0 : _a.shared[name]; };
